// Module
var code = "<form name=\"vm.forms.cdSshKeyForm\" novalidate> <cd-ssh-key-generator cd-user=\"vm.user\"></cd-ssh-key-generator> </form> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/cd-ssh-key.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;